<template>
    <div class="fs5-franchise-message">
        <div class="header ba-card" v-html="view[0].t.fs5_franchise_message"></div>
        <fs5-view-rank-details :view="view[1]"></fs5-view-rank-details>
        <br>
        <fs5-get-paid-collapse
            :view="view[2]">
            <div :slot="'content'" slot-scope="props">
                <fs5-get-paid-tutorial :view="props.content"></fs5-get-paid-tutorial>
            </div>
        </fs5-get-paid-collapse>
        <br>
        <div class="box-all">
            <div class="box-item-one">
                <p class="title-message" v-html="view[0].t.messages"></p>
                <div>
                    <input :class="['input-data-simple', stateSubject ? 'error-input' : !subject ? '' : 'success-input']" type="text" :placeholder="view[0].t.enter_subject" v-model="subject">
                    <span v-if="stateSubject" class="error-message" v-html="view[0].t.invalid_subject"></span>
                </div>
                <div>
                    <textarea :class="['input-data-simple', stateMessage ? 'error-input' : !message ? '' : 'success-input']" rows="10" cols="50" :placeholder="view[0].t.type_your_messsage" v-model="message"></textarea>
                    <span v-if="stateMessage" class="error-message" v-html="view[0].t.invalid_message"></span>
                </div>
                <div>
                    <input :class="['input-data-simple', regexUrl ? 'success-input' : url.length > 0 ? 'error-input' : '']" type="text" :placeholder="decodeString(view[0].t.fs5_type_your_url)" v-model="url">
                    <span v-if="!regexUrl && url.length > 0" class="error-message" v-html="view[0].t.fs5_invalid_url"></span>
                </div>
            </div>
            <div class="box-item-two">
                <p class="title-message" v-html="view[0].t.fs5_form_of_contact"></p>
                <div class="subbox-type-send">
                    <div>
                        <input type="checkbox" id="notification" name="notification" value="notification" v-model="typeNotification">
                        <label for="notification" v-html="view[0].t.notification"></label>
                    </div>
                    <div>
                        <input disabled type="checkbox" id="sms" name="sms" value="sms">
                        <label for="sms" v-html="view[0].t.menu_sms"></label>
                    </div>
                    <div>
                        <input type="checkbox" id="translation" name="translation" value="translation" v-model="typeTranslation">
                        <label for="translation" v-html="view[0].t.fs5_automatic_translation"></label>
                    </div>
                </div>
                <div class="title-all-recipients">
                    <div>
                        <p class="title-message">{{ view[0].t.fs5_send_to }} <b>({{ qtdRecipients }})</b></p>
                        <p class="subtitle-select-recipients" v-html="view[0].t.fs5_select_one_recipient"></p>
                    </div>
                    <div class="input-data-simple input-data-search">
                        <input type="text" v-model="dataSearch.value" @keyup="searchLeads()" :placeholder="view[0].t.search_email_name">
                        <button v-if="!dataSearch.value" @click="searchLeads()" class="btn-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="icon-search bi bi-search" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                            </svg>
                        </button>
                        <button v-if="dataSearch.value.length > 0" @click="cleanSearch()" class="btn-icon" :title="view[0].t.clear_search">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                            </svg>
                        </button>
                    </div>
                </div>
                <div class="box-recipients">
                    <table v-if="showTable" class="table-recipients">
                        <tr>
                            <td v-for="option,i in view[0].options" :key="i">
                                <input v-if="option.title != null" type="checkbox" :id="option.value" :value="option" v-model="recipients" @change="selectRecipient(option.value)">
                                <label v-if="option.title != null" :for="option.value" v-html="option.title"></label>
                            </td>
                            <td>
                                <select :id="'leads-plan'" v-model="plan.value" class="form-control">
                                  <option value="" disabled><span v-html="view[0].t.plan"></span></option>
                                  <option value="MB_TAG:BUILDER">BUILDERALL BUILDER</option>
                                  <option value="MB_TAG:MARKETER">MARKETER</option>
                                  <option value="MB_TAG:PREMIUM">PREMIUM</option>
                                  <option value="MB_TAG:FC">FUNNEL CLUB</option>
                                  <option value="MB_TAG:LEGACY">LEGACY</option>
                                </select>
                                <span class="glyphicon glyphicon-info-sign" data-html="true" data-toggle="tooltip" data-placement="right" :title="view[0].t.plan_helper"></span>
                            </td>
                        </tr>
                    </table>
                    <div v-if="!showTable" class="first-box-leads">
                        <div v-if="showSpinner">
                            <spring-spinner :animation-duration="2000" :size="35" color="#0080fc"/>
                        </div>
                        <div v-if="!showSpinner && dataSearch.leads.length == 0">
                            <p v-html="view[0].t.no_register"></p>
                        </div>
                        <div v-for="option,i in dataSearch.leads" :key="i" class="second-box-leads" @click="selectLeadSearch(option)">
                            <img :src="option.lead.image">
                            <label :for="option.lead.id" v-html="option.title"></label>
                        </div>
                    </div>
                </div>
                <div :class="[leadsSelected.length > 2 ? 'box-item-scroll' : '']">
                    <div v-if="leadsSelected.length > 0" class="first-box-leads border-top">
                        <div v-for="option,i in leadsSelected" :key="i" class="second-box-leads">
                            <img :src="option.lead.image">
                            <label :for="option.lead.id" v-html="option.title"></label>
                            <span @click="selectLeadSearch(option)" class="btn-remove-lead" :title="view[0].t.remove_lead">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                </div>
                <div>
                    <fs5-button
                        :label="view[0].t.send"
                        :btn-type="'primary'"
                        @clicked="validationSubmit()"
                        :disabled="(subject == '' || message == '' || (url != '' && !regexUrl ? true : false) || (recipients.length > 0 || leadsSelected.length > 0 || this.plan.value != '' ? false : true) || (!typeNotification && !typeSms && !typeTranslation ? true : false)) ? true : false"
                    ></fs5-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { SpringSpinner } from 'epic-spinners'
    export default {
        name: 'fs5-franchise-message',
        props: ['view'],
        components: {
            'spring-spinner': SpringSpinner
        },
        data() {
            return {
                stateSubject: false,
                stateMessage: false,
                regexUrl: false,
                typeTranslation: true,
                typeSms: false,
                typeNotification: true,
                recipients: [],
                plan: {
                  title:'Mailingboss Tag',
                  value:''
                },
                leadsSelected: [],
                qtdRecipients: 0,
                checkAll: false,
                showSpinner: false,
                showTable: true,
                dataSearch: {
                    leads: [],
                    value: ''
                },
                subject: '',
                message: '',
                url: ''
            }
        },
        methods: {
            decodeString(val) {
              return new DOMParser().parseFromString(val, 'text/html').querySelector('body').textContent;
            },
            validationSubmit()
            {
                // Validation
                if(this.subject == '' && this.message == '')
                {
                    this.stateSubject = true;
                    this.stateMessage = true;
                    this.showToast('error',this.view[0].t.complete_correctly_fields);
                }
                else if(this.subject == '')
                {
                    this.stateSubject = true;
                    this.showToast('error',this.view[0].t.enter_valid_subject);
                }
                else if(this.message == '')
                {
                    this.stateMessage = true;
                    this.showToast('error',this.view[0].t.enter_valid_message);
                }
                else if(this.url != '' && !this.regexUrl)
                {
                    this.showToast('error',this.view[0].t.enter_valid_url);
                }
                else if(!this.typeNotification && !this.typeSms && !this.typeTranslation)
                {
                    this.showToast('error',this.view[0].t.select_one_method_delivery_message);
                }
                else if(this.recipients == '' && this.leadsSelected == '' && this.plan.value == '')
                {
                    this.showToast('error',this.view[0].t.fs5_select_one_recipient);
                }
                else
                {
                    this.submitMessage();
                }
            },
            submitMessage()
            {
                this.showSpinner = true;
                this.showTable = false;
                this.dataSearch = {leads: [], value: ''};
                // if exists all_leads, submit just all_leads more leadsSelected
                let checkAll = this.recipients.length > 0 ? this.recipients[0].value.indexOf('ALL_LEADS') : -1;
                // construct form
                let form = {
                    email: false,
                    notification: this.typeNotification,
                    translation: this.typeTranslation,
                    whatsapp: false,
                    sms: this.typeSms,
                    subject: this.subject,
                    message: this.message,
                    to: (checkAll != -1 ? [this.recipients[0]] : this.recipients).concat(this.leadsSelected),
                    action: {
                        text: '',
                        url: this.url
                    }
                };

                if(this.plan.value != ''){
                    form.to = form.to.concat(this.plan);
                }

                // Submit message
                axios
                    .post(this.view[0].routes.messages, form)
                    .then((response) => {
                        if(response.data.status == 'success')
                        {
                            this.showToast('success',this.view[0].t.message_sent_successfully);
                        }
                        else
                        {
                            this.showToast('error',this.view[0].t.error_sending_message);
                        }
                        this.showTable = true;
                        this.showSpinner = false;
                    })
                    .catch(e => {
                        this.showSpinner = false;
                        this.showTable = true;
                        this.showToast('error',this.view[0].t.error_sending_message);
                    });
            },
            showToast(type,data)
            {
                alertMsg(type,data);
            },
            selectRecipient(data)
            {
                // Method with rules for selecting recipients
                let sub = 0;
                if(data == 'ALL_LEADS')
                {
                    // When selecting 'ALL_LEADS' it clears everything and checks or not
                    this.recipients = [];
                    this.checkAll = !this.checkAll;
                }
                else
                {
                    if(this.checkAll)
                    {
                        // When selecting an item != 'ALL_LEADS', uncheck the 'ALL_LEADS' if it is checked
                        this.checkAll = false;
                        // Remove all leads
                        this.recipients.splice(0, 1);
                    }
                }
                // Select all if all leads is selected or all are selected except all leads
                if(this.checkAll || this.recipients.length + 1 == this.view[0].options.length)
                {
                    // Due to the size, all leads may not be selected, so we selected
                    this.checkAll = true;
                    // Select all
                    for(let i = 0; i < this.view[0].options.length; i++)
                    {
                        this.recipients[i] = this.view[0].options[i];
                    }
                    // Since ALL_LEADS does not count for removal count
                    sub = 1;
                }
                this.qtdRecipients = (this.recipients.length + this.leadsSelected.length) - sub;
            },
            selectLeadSearch(data)
            {
                // Method to select leads from search, remove from search and add to leadsSelected
                // When selecting arrow search leads in the array, if it exists, it excludes it, if it does not exist arrow
                let item = this.leadsSelected.map(x => x.value).indexOf(data.value);
                let itemSearch = this.dataSearch.leads.map(x => x.value).indexOf(data.value);
                let checkAll = this.recipients.length > 0 ? this.recipients[0].value.indexOf('ALL_LEADS') : -1;
                let sub = 0;
                if(item == -1)
                {
                    // Lead has not yet been selected. set
                    this.leadsSelected.push(data);
                    // Remove on search
                    this.dataSearch.leads.splice(itemSearch,1);
                }
                else
                {
                    // Lead selected. Remove
                    this.leadsSelected.splice(item,1);
                    // Insert on search
                    this.dataSearch.leads.push(data);
                }
                if(checkAll != -1)
                {
                    // Since ALL_LEADS does not count for removal count
                    sub = 1;
                }
                this.qtdRecipients = (this.recipients.length + this.leadsSelected.length) - sub;
            },
            searchLeads()
            {
                // Method for researching leads
                if(!this.dataSearch.value)
                {
                    this.showTable = true;
                    return;
                }
                this.dataSearch.leads = [];
                this.showTable = false;
                this.showSpinner = true;
                // Timer for not making the request too often
                setTimeout(() => {
                    // ignore id user selected
                    let ignore;
                    if(this.leadsSelected.length > 0)
                    {
                       ignore = this.leadsSelected.map(t => t.lead.id, this.leadsSelected.filter(t => t.lead, this.leadsSelected));
                       ignore = ignore.join(';').toString();
                    }
                    else
                    {
                        ignore = '';
                    }
                    // make a search
                    axios
                        .get(this.view[0].routes.leads+'?search='+this.dataSearch.value+'&ignore='+ignore)
                        .then((response) => {
                            this.dataSearch.leads = response.data.data.map(l => ({
                                id: l.id,
                                title: l.name,
                                value: `LEAD_${l.id}`,
                                lead: l
                            }), response.data.data);
                            this.showSpinner = false;
                        })
                        .catch(e => {this.showSpinner = false;});
                }, 200);
            },
            cleanSearch()
            {
                // clear search
                this.dataSearch.value = '';
                this.showTable = true;
            }
        },
        watch: {
            subject()
            {
                if(!this.subject)
                {
                    this.stateSubject = true;
                    return;
                }
                this.stateSubject = false;
            },
            message()
            {
                if(!this.message)
                {
                    this.stateMessage = true;
                    return;
                }
                this.stateMessage = false;
            },
            url()
            {
                let regex = /^http(s?):\/\//;
                if(regex.exec(this.url) != null)
                {
                    this.regexUrl = true;
                }
                else
                {
                    this.regexUrl = false;
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../../scss/extras/_variables';
    .header{
        color: $fs5-color11;
        line-height: 1.2;
        font-weight: 900;
        font-size: 1.5em;
        margin-bottom: 0.7em;
        text-transform: uppercase;
    }
    .box-all{
        font-family: Lato;
        display: flex;
        flex-direction: row;
        gap: 5%;
        background-color: $fs5-color2;
        padding: 2em 3em;
        border: 1px solid $fs5-color1;
        border-radius: 8px;
        .box-item-one,
        .box-item-two{
            padding: 1em;
            gap: 4%;
            width: 50%;
        }
        .box-item-one{
            display: flex;
            flex-direction: column;
        }
        .border-top{
            border-top: 1px solid $fs5-color1;
            padding-top: 1em;
        }
        .box-item-two{
            display: grid;
            grid-template-rows: auto 1fr 1fr 3fr auto 1fr;
            .table-recipients{
                width: 100%;
                tr{
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr;
                    grid-column-gap: 1%;
                    align-items: center;
                    td{
                        padding: 0.2em;
                        display: flex;
                        flex-direction: row;
                        gap: 3%;
                        label{
                            color: $fs5-color24;
                            font-weight: 600;
                        }
                    }
                }
            }
            .btn-icon{
                background-color: transparent;
                border: none;
                outline: none;
            }
            .subtitle-select-recipients{
                color: $fs5-color26;
                font-size: 0.8em;
                margin-top: 0.4em;
            }
            .title-all-recipients,
            .subbox-type-send{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }
            .first-box-leads{
                display: flex;
                flex-direction: row;
                gap: 2%;
                flex-wrap: wrap;
            }
            .second-box-leads{
                display: flex;
                flex-direction: row;
                align-items: center;
                background-color: $fs5-color1;
                border-radius: 1em;
                margin: 0.4em;
                cursor: pointer;
                img {
                    width: 2em;
                    border-radius: 50%;
                    cursor: pointer;
                }
                label {
                    padding: 0.3em 0.6em;
                    cursor: pointer;
                }
            }
            .second-box-leads:hover{
                background-color: $fs5-color34;
            }
            .box-recipients{
                display: flex;
                align-items: center;
            }
        }
        .success-input{
            border: 1px solid $fs5-color16 !important;
        }
        .error-message{
            color: $dv5-color11;
            font-size: 0.9em;
        }
        .error-input{
            border: 1px solid $dv5-color11 !important;
        }
        .box-item-scroll{
            overflow-x: auto;
        }
        .title-message{
            margin: 0;
            color: $fs5-color24;
            font-weight: bold;
            font-size: 1.25em;
        }
        .btn-remove-lead{
            padding: 0 0.4em;
        }
        .input-data-search{
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 50% !important;
            height: 2.5em !important;
            text-align: center;
            input{
                width: 90%;
                border: none;
                outline: none;
            }
            .icon-search{
                color: $fs5-color5;
                cursor: pointer;
            }
        }
        .input-data-simple{
            border: 1px solid $fs5-color25;
            color: $fs5-color27;
            outline: none;
            padding: 0.5em;
            border-radius: 5px;
            width: 100%;
        }
    }
    @media only screen and (max-width: 1280px) {
        .box-all {
            flex-direction: column;
            padding: 1em !important;
            .box-item-one{
                row-gap: 1em !important;
            }
            .box-item-two{
                gap: 2% !important;
            }
            .box-item-one,
            .box-item-two{
                width: 100% !important;
                .input-data-search{
                    width: 100% !important;
                }
                .subbox-type-send,
                .title-all-recipients{
                    flex-wrap: wrap !important;
                }
            }
        }
    }
    @media only screen and (max-width: 620px) {
        .table-recipients tr{
            grid-template-columns: 1fr 1fr !important;
        }
        .subbox-type-send{
            align-items: flex-start !important;
            flex-direction: column !important;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/franchise_message/index.vue